<template>
	<section class="newsletter">
		<div class="row align-center">
			<div class="columns column12">
				<h3>{{ header }}</h3>
				<div v-parse-links v-html="content" />
				<div id="mc_embed_shell">
					<div id="mc_embed_signup">
						<form
							id="mc-embedded-subscribe-form"
							action="https://delphihotel.us20.list-manage.com/subscribe/post?u=6182bf7621649e8f107fd6c8e&id=a758f97fc6&f_id=008e71eef0"
							method="post"
							name="mc-embedded-subscribe-form"
							class="validate newsletter"
							target="_blank"
						>
							<input
								id="mce-EMAIL"
								type="email"
								name="EMAIL"
								class="required email"
								required=""
								value=""
								:placeholder="$t('formEmail')"
							/>

							<div aria-hidden="true" style="position: absolute; left: -5000px">
								<input
									type="text"
									name="b_6182bf7621649e8f107fd6c8e_a758f97fc6"
									tabindex="-1"
									value=""
								/>
							</div>

							<input
								id="mc-embedded-subscribe"
								type="submit"
								name="subscribe"
								class="button"
								:value="button"
							/>
						</form>
					</div>
				</div>
			</div>
		</div>
		<picture>
			<source v-if="image.imageWebp" :srcset="image.imageWebp" type="image/webp" />
			<source :srcset="image" />
			<img class="fade-image" :src="image.image" :alt="image.imageAlt" loading="lazy" />
		</picture>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
	image: {
		type: Object,
		default: () => ({
			image: '',
			imageAlt: '',
			imageWebp: '',
		}),
	},
});
</script>

<style lang="scss" scoped>
.fade-image {
	opacity: 1;
}

section.newsletter {
	position: relative;
	padding: 150px 0;

	.row {
		position: relative;
		z-index: 3;
		max-width: 560px;
		background: rgb(51 84 56 / 80%);
		backdrop-filter: blur(34px);
		margin: 0 auto;
		padding: 40px 20px;
	}

	p {
		max-width: 600px;
		margin: 0 auto 20px;
	}

	input {
		appearance: none;
	}

	input:not(.button) {
		color: var(--body-color);
		border: none;
		width: 280px;
		padding: 0 10px;
		line-height: 50px;
		outline: none !important;
		background: none;
		font-size: 16px;
		font-weight: 300;
	}

	.button {
		border: none;
		margin: 0;
		cursor: pointer;
		outline: none;
	}
}

.package-subpage section.newsletter {
	padding: 50px 0;
}

section.newsletter,
.newsletter h2 {
	color: #fff;
}

form.newsletter {
	background: #12170f;
	color: #fff;
	padding: 10px;
	display: inline-block;
	margin: 0 auto;
}

::placeholder {
	color: #fff;
}

@media (max-width: 680px) {
	section.newsletter input,
	section.newsletter input:not(.button) {
		width: 100%;
		text-align: center;
	}

	section.newsletter {
		.row {
			padding: 30px 10px;
		}
	}
}
</style>
